import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditProjectResourceNotificationState = createStateReducer(
  initialState,
  {
    [events.editProjectResourceSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectResource",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editProjectResourceFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectResource",
          flags: [],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceEditProjectResourceNotificationState };
